import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import DashboardHeader from '../../components/dasboardHeader/index.vue'
import SideNav from '../../components/sideNavBar/index.vue'
import TimeApprovalRatingModal from '../../components/TimeApprovalRatingModal/index.vue'
import TimeApprovalActionModal from '../../components/TimeApprovalActionModal/index.vue'
import TimeApprovalRejectModal from '../../components/TimeApprovalRejectModal/index.vue'
import RaiseAQueryModal from '../../components/RaiseAQueryModal/index.vue'
import JobService from '../../services/jobService'
// import Shepherd from 'shepherd.js'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      modalActive: false,
      // userOnBoardingStatuss: false,
      modalApprovalActive: false,
      modalRajectActive: false,
      modalRaiseAQueryActive: false,
      jobs: [],
      constJobs: [],
      id: '',
      logId: '',
      rejId: '',
      rejLogID: '',
      hospitals: [],
      professions: [],
      loading: false,
      jobId: '',
      jobDate: '',
      department: '',
      professionalId: '',
      userName: '',
      selected: '',
      selected2: '',
      showMessage: false,
      showMessage2: false,
      showMessage3: false,
      showMessage4: false,
      search1: '',
      search2: '',
      search3: '',
      search4: '',
      startT: '',
      endT: '',
      sort: false
    }
  },
  components: {
    DashboardHeader,
    SideNav,
    TimeApprovalRatingModal,
    TimeApprovalActionModal,
    TimeApprovalRejectModal,
    RaiseAQueryModal
  },
  mounted () {
    // window.analytics.page('timeApprovalJobs')
    window.analytics.identify('timeApprovalJobs', {
      path: '/timeApprovalJobs'
    })
    // if (JSON.parse(localStorage.getItem('tourToken')).userOnBoardingStatus === 'no') {
    //   this.jobs = [{
    //     code: '1111',
    //     department: 'dummy',
    //     user: 'yyyyyyy',
    //     date: '1667476140000',
    //     end: '1667476140000',
    //     in: '1667476140000',
    //     out: '1667476140000',
    //     cost: '2222',
    //     filled: '0/1',
    //     id: 'abcd11111',
    //     shift: 'dummy',
    //     specialization: 'abcd',
    //     start: '1667476140000'
    //   }]
    //   const tour = new Shepherd.Tour({
    //     defaultStepOptions: {
    //       cancelIcon: {
    //         enabled: false
    //       },
    //       scrollTo: {
    //         behavior: 'smooth',
    //         block: 'center'
    //       },
    //       arrow: false,
    //       modalOverlayOpeningPadding: 10
    //     },
    //     useModalOverlay: true
    //   })
    //   tour.addStep({
    //     attachTo: { element: '.step16', on: 'bottom' },
    //     text: 'This is time approval page',
    //     buttons: [
    //       {
    //         text: 'Skip',
    //         action () {
    //           localStorage.setItem('tourToken', JSON.stringify({
    //             userOnBoardingStatus: 'yes'
    //           }))
    //           location.reload()
    //           // window.location.href = '/#/dashboard'
    //         }
    //       },
    //       {
    //         text: '<< Back',
    //         action () {
    //           return this.back()
    //         }
    //       },
    //       {
    //         text: 'Next >>',
    //         action () {
    //           return this.next()
    //         }
    //       }
    //     ]
    //   })
    //   tour.addStep({
    //     attachTo: { element: '.step17', on: 'bottom' },
    //     text: 'Click here to approve the candidate once shift is done',
    //     buttons: [
    //       {
    //         text: 'Skip',
    //         action () {
    //           localStorage.setItem('tourToken', JSON.stringify({
    //             userOnBoardingStatus: 'yes'
    //           }))
    //           location.reload()
    //           // window.location.href = '/#/dashboard'
    //         }
    //       },
    //       {
    //         text: '<< Back',
    //         action () {
    //           return this.back()
    //         }
    //       },
    //       {
    //         text: 'Next >>',
    //         action () {
    //           return this.next()
    //         }
    //       }
    //     ]
    //   })
    //   tour.addStep({
    //     attachTo: { element: '.step18', on: 'bottom' },
    //     text: 'Click here to disapprove the candidate on job completion',
    //     buttons: [
    //       {
    //         text: 'Finish',
    //         action () {
    //           window.location.href = '/#/dashboard'
    //           localStorage.setItem('tourToken', JSON.stringify({
    //             userOnBoardingStatus: 'yes'
    //           }))
    //           return this.next()
    //         }
    //       }
    //     ]
    //   })
    //   tour.start()
    // }
  },
  async created () {
    // if (JSON.parse(localStorage.getItem('tourToken')).userOnBoardingStatus === 'yes') {
    console.log('in created')
    this.loading = true
    this.jobs = await JobService.listMiniJobShiftLogs()
    this.constJobs = this.jobs
    this.hospitals = await JobService.listBranches()
    this.professions = await JobService.listProfessions()
    this.loading = false
    // }
  },
  methods: {
    ratingModal () {
      this.modalActive = true
      document.body.classList.add('overlay-bg')
    },
    actionApproval (id, log, intime, outtime) {
      this.id = id
      this.logId = log
      this.startT = intime
      this.endT = outtime
      this.modalApprovalActive = true
      document.body.classList.add('overlayBg')
    },
    actionRaject (id, log) {
      this.rejId = id
      this.rejLogID = log
      this.modalRajectActive = true
      document.body.classList.add('reject_modal_open')
    },
    actionRaiseAQuery (code, date, department, userName, professionalId) {
      this.jobId = code
      this.jobDate = date
      this.department = department
      this.userName = userName
      this.professionalId = professionalId
      this.modalRaiseAQueryActive = true
      document.body.classList.add('raise_query_modal')
    },
    async close (bool) {
      if (!bool) this.modalActive = !this.modalActive
      else this.modalActive = null
      document.body.classList.remove('overlay-bg')
      this.jobs = await JobService.listMiniJobShiftLogs()
    },
    async closePhone (bool) {
      if (!bool) this.modalApprovalActive = !this.modalApprovalActive
      else this.modalApprovalActive = null
      document.body.classList.remove('overlayBg')
      this.jobs = await JobService.listMiniJobShiftLogs()
    },
    async closeRaject (bool) {
      if (!bool) this.modalRajectActive = !this.modalRajectActive
      else this.modalRajectActive = null
      document.body.classList.remove('reject_modal_open')
      this.jobs = await JobService.listMiniJobShiftLogs()
    },
    async closeRaiseAQuery (bool) {
      if (!bool) this.modalRaiseAQueryActive = !this.modalRaiseAQueryActive
      else this.modalRaiseAQueryActive = null
      document.body.classList.remove('reject_modal_open')
      this.jobs = await JobService.listMiniJobShiftLogs()
    },
    departmentSearch () {
      this.jobs = this.constJobs
      // console.log(this.jobs)
      const filteredJobs = this.jobs.filter(job => {
        return job.department.toLowerCase().includes(this.search1.toLowerCase())
      })
      this.jobs = filteredJobs
      // this.search1 = ''
      this.showMessage = false
    },
    specializationSearch () {
      this.jobs = this.constJobs
      // console.log(this.jobs)
      const filteredJobs = this.jobs.filter(job => {
        return job.specialization.toLowerCase().includes(this.search2.toLowerCase())
      })
      this.jobs = filteredJobs
      this.showMessage2 = false
    },
    shiftSearch () {
      this.jobs = this.constJobs
      const filteredJobs = this.jobs.filter(job => {
        return job.shift.toLowerCase().includes(this.search3.toLowerCase())
      })
      this.jobs = filteredJobs
      this.showMessage3 = false
    },
    nameSearch () {
      this.jobs = this.constJobs
      const filteredJobs = this.jobs.filter(job => {
        return job.user.toLowerCase().includes(this.search4.toLowerCase())
      })
      this.jobs = filteredJobs
      this.showMessage4 = false
    },
    async reset () {
      await this.$router.push('/upcoming_jobs')
      this.$router.push('/time_approval_jobs')
    },
    async onChange (event) {
      // this.selected2 = ''
      const hospitalId = event.target.value
      // console.log(event.target.value)
      this.jobs = await JobService.listMiniJobShiftLogsProfession(this.selected2, hospitalId)
      // console.log(this.jobs)
    },
    async onChange2 (event) {
      // this.selected = ''
      const professionId = event.target.value
      this.jobs = await JobService.listMiniJobShiftLogsProfession(professionId, this.selected)
      // console.log(this.jobs)
    },
    getDate (data) {
      const date = parseInt(data)
      const res = Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).format(new Date(date))
      return res.split(',')
    },
    convertDate (d) {
      const d1 = new Date(d).toLocaleDateString()
      // console.log(d1)
      var p = d1.split('/')
      return (p[2] + p[1] + p[0])
    },
    sortByDate () {
      console.log('call')
      const that = this
      var tbody = document.querySelector('.table tbody')
      var rows = [].slice.call(tbody.querySelectorAll('tr'))
      if (!this.sort) {
        rows.sort(function (a, b) {
          return that.convertDate(a.cells[5].innerHTML) - that.convertDate(b.cells[5].innerHTML)
        })
        rows.forEach(function (v) {
          tbody.appendChild(v)
        })
      } else if (this.sort) {
        rows.sort(function (a, b) {
          return that.convertDate(b.cells[5].innerHTML) - that.convertDate(a.cells[5].innerHTML)
        })
        rows.forEach(function (v) {
          tbody.appendChild(v)
        })
      }
      this.sort = !this.sort
    },
    sortId () {
      if (!this.sort) {
        this.jobs = this.constJobs
        const sortedJobs = this.jobs.sort((a, b) => {
          const start = a.code.substring(2)
          const end = b.code.substring(2)
          return start - end
        })
        this.jobs = sortedJobs
      } else if (this.sort) {
        this.jobs = this.constJobs
        const sortedJobs = this.jobs.sort((a, b) => {
          const start = a.code.substring(2)
          const end = b.code.substring(2)
          return end - start
        })
        this.jobs = sortedJobs
      }
      this.sort = !this.sort
    }
  }
}
